import { useEffect, useState } from "react";
import { Icon } from '@iconify/react';
import axios from "axios";
const EmergencyContact = () => {
    const [contact, setContact] = useState([]);
    useEffect(() => {
        axios.get('/api/student/get-emergency-contact-details', {
        withCredentials: true
        })
        .then((response) => setContact(response.data))
        .catch((error) => console.error('Error fetching emergency contact:', error));
    }, []);
    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">Emergency Contact Details</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-grey ">
                            <div className="pb-24 ms-16  me-16">
                                <div className="mt-24">
                                    
                                    <div className="row gy-3">
                                        <div className="col-12">
                                            <label className="form-label h6"><Icon icon="iconoir:user"  className="w-60" /> Contact Person Name </label>: {contact?.contact_person_name}
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label h6"><Icon icon="iconoir:phone"  className="w-60" /> Contact Number </label>: {contact?.contact_number}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EmergencyContact;